<template>  
  <myHeader /> 
  <warheadSection v-on:click_checkbox = "click_checkbox" 
                  v-on:check_all_thing = "check_all_thing" 
                  v-bind:warheadData = "warheadData" 
                  v-bind:section_warhead_visible = "section_warhead_visible"
                  SecTitle="residues"  /> 

  <residueSection v-on:click_checkbox = "click_checkbox" 
                  v-on:check_all_thing = "check_all_thing" 
                  v-bind:residueData = "residueData" 
                  v-bind:section_residue_visible = "section_residue_visible"
                  SecTitle="binders" />  

  <binderSection  v-on:click_checkbox = "click_checkbox" 
                  v-on:check_all_thing = "check_all_thing" 
                  v-bind:binderData = "binderData" 
                  v-bind:section_binder_visible = "section_binder_visible"
                  SecTitle="records"  /> 
                   
  <recordList     v-on:click_checkbox = "click_checkbox"  
                  v-bind:recordData = "recordData" 
                  v-bind:section_record_visible = "section_record_visible" />
  
  <div v-if="section_no_matched_result_visible">
    No record in CovBinderInPDB matches your search request. Please try another query.
  </div>
</template>

 
<script>
import          axios from 'axios';
import residueSection from '@/components/explore/residueSection.vue'
import warheadSection from '@/components/explore/warheadSection.vue'
import  binderSection from '@/components/explore/binderSection.vue'
import     recordList from '@/components/explore/recordList.vue'
import       myHeader from '@/components/header.vue' 

export default {
  name: 'App', 
  data () {
    return {   
      initBinderIdList : [],                     
      residues: [],
      warheads: [],
      binders : [],
      residueData  : {},
      warheadData  : {},
      binderData   : {},
      recordData   : {},
      section_residue_visible           : false,
      section_warhead_visible           : false,
      section_binder_visible            : false,
      section_record_visible            : false,
      section_residue_all_checked       : false,
      section_warhead_all_checked       : false,
      section_binder_all_checked        : false,
      section_no_matched_result_visible : false,
    }
  }, 
  components: {
    recordList, binderSection, warheadSection, residueSection, myHeader
  },  

  mounted () { 
    var x    = document.getElementById('flask_data');  
    var url  = x.getAttribute("url");
    var type = x.getAttribute("type");
    axios.get(url)
          .then(response => {
            console.log(response.data.initBinderIdList)
            if (type=='subgroup') {
              this.section_warhead_visible     = true; 
              this.section_residue_visible     = true;
              this.section_binder_visible      = true;
              this.section_residue_all_checked = true ;
              this.section_warhead_all_checked = true ; 
              this.warheadData                 = response.data.warheadData;  
              this.residueData                 = response.data.residueData; 
              this.binderData                  = response.data.binderData ; 
              for (const[k,v] of Object.entries(this.residueData)) {
                this.residues.push(v['name']); k;
              }
              for (const[k,v] of Object.entries(this.binderData)) {
                this.initBinderIdList.push(v['binder_id']); k;
              } 

            } else if (type=='search') {
              this.section_warhead_visible = true; 
              this.warheadData             = response.data.warheadData;  
              this.initBinderIdList        = response.data.initBinderIdList;

            } else if (type=='record') {  
              this.recordData = response.data; 
              console.log(this.recordData);
              if (Object.keys(this.recordData).length > 0) {  
                this.section_record_visible = true;
              } else { 
                this.section_no_matched_result_visible = true;
              }
            }
          } ) 
  },

  methods: {
    checked_sth: function (name) {
      var y = [];
      var x = document.getElementsByName(name); 
      for (var i = 0; i < x.length; i++)
        if (x[i].checked == true)
          y.push(x[i].value);  
      // console.log(name, ':', y)v 
      return y;
    }, 

    check_all_thing: function (boxName) {  
      if        (boxName=="checkbox_residue") {
        this.section_residue_all_checked  = !this.section_residue_all_checked  ;
        var flag = this.section_residue_all_checked ;  
      } else if (boxName=="checkbox_warhead") {
        this.section_warhead_all_checked = !this.section_warhead_all_checked ;
        flag = this.section_warhead_all_checked ; 
      } else if (boxName=="checkbox_binder") {
        this.section_binder_all_checked  = !this.section_binder_all_checked  ;
        flag = this.section_binder_all_checked ; 
      }

      var x = document.getElementsByName(boxName);  
      for (var i = 0; i < x.length; i++)
        x[i].checked = flag; 
      this.click_checkbox(boxName);

    }, 

    click_checkbox: function (boxName) { 
      if (boxName=='checkbox_warhead') { 
        this.warheads = this.checked_sth(boxName);
        if (this.warheads.length > 0) {
          axios.post('binder_residues', 
                 {'initBinderIdList':this.initBinderIdList,
                  'warheads':this.warheads})
               .then(response => {  
                 this.residueData=response.data;
                 this.section_residue_visible = true;
               }); 
        } else { 
          this.residueData={}; 
          this.binderData={}; 
          this.recordData={}; 
          this.section_residue_visible = false;
          this.section_binder_visible = false;
          this.section_record_visible = false;
          } 
      } else if (boxName=='checkbox_residue') { 
        this.residues = this.checked_sth(boxName); 
        if (this.residues.length > 0) {
          axios.post('binder_binders', 
                 {'initBinderIdList':this.initBinderIdList,
                  'warheads': this.warheads,
                  'residues': this.residues})
               .then(response => {  
                 this.binderData=response.data;  
                 this.section_binder_visible = true;
               }); 
        } else {  
          this.binderData={}; 
          this.recordData={};  
          this.section_binder_visible = false;
          this.section_record_visible = false;
          }
      } else if (boxName=='checkbox_binder') { 
        this.binders = this.checked_sth(boxName);
        if (this.binders.length > 0) { 
          axios.post('residue_records', 
                 {'residues':this.residues,
                  'binders' :this.binders})
               .then(response => {
                 this.recordData=response.data;  
                 this.section_record_visible = true;
               }); 
        } else {  
          this.recordData={};  
          this.section_record_visible = false;
        } 
      } else if (boxName=='download') { 
        if (this.binders.length > 0) {  

          var form = document.createElement('form'); 
          form.setAttribute('method', 'post'); 
          form.setAttribute('action', 'residue_download');
          form.setAttribute(    'id', 'residue_download_id'); 
          form.style.display = 'none';

          var inp = document.createElement('input'); 
          inp.setAttribute('type', 'text');
          inp.setAttribute('name', 'foo');
          inp.setAttribute('value', JSON.stringify({'residues': this.residues, 'binders' : this.binders}));

          form.appendChild(inp);  
          document.body.appendChild(form); 
          document.getElementById("residue_download_id").submit(); 
          document.body.removeChild(form); 
 
        } else {
          var record_ids = []; 
          for (const[k,v] of Object.entries(this.recordData)) {
            record_ids.push(v['record_id']); k;
          }    
          /*
          <form action="/action_page.php"> 
            <input type="text" id="fname" name="fname" value="John"><br>  
          </form>
          */ 
          form = document.createElement('form'); 
          form.setAttribute('method', 'post'); 
          form.setAttribute('action', 'record_download');
          form.setAttribute(    'id', 'record_download_id'); 
          form.style.display = 'none';

          inp = document.createElement('input'); 
          inp.setAttribute('type', 'text');
          inp.setAttribute('name', 'foo');
          inp.setAttribute('value', JSON.stringify({ 'record_ids' : record_ids}));

          form.appendChild(inp);  
          document.body.appendChild(form); 
          document.getElementById("record_download_id").submit(); 
          document.body.removeChild(form); 

        }  
      }
    },
  }
}
</script>


<style scoped>  
</style>
